import React, { useEffect, useState } from 'react'
import HeaderNew from './HeaderNew'
import FooterNew from './FooterNew'
import bannerVideo from '../Assets/ainfra/videos/compute.mp4'
import { GetAllCmsData } from '../Hooks/UseBackend'


const AIcompute = () => {
    const [CmsData, setCmsData] = useState([]);
    const [section1, setsection1] = useState();
    useEffect(() => {
        window.scrollTo({
            left: 0,
            top: 0,
            behavior: "smooth"
        });
    }, []);

    useEffect(() => {
        getCmsData();
    }, []);


    const getCmsData = async () => {
        console.log("enterthis");
        let res = await GetAllCmsData();

        if (res.data) {
            setsection1(res.data.find((value) => (value.identifier == 'AI Compute')))
        }


        setCmsData(res.data);
    };
    return (
        <div>
            <HeaderNew />
            <main className=''>

                <section className='section-videoBanner'>
                    <div className='section-videoBanner__videoContainer'>
                        <video autoPlay muted loop className='section-videoBanner__video' >
                            <source src={bannerVideo} type="video/mp4" />
                        </video>
                    </div>
                    <div className='container ai-container'>
                        <div className='section-videoBanner__content'>
                            <p className='section-videoBanner__content-title'>{section1 && section1?.Title}</p>
                            <p className='section-videoBanner__content-desc'>{section1 && section1?.Content}</p>
                            <div className='section-videoBanner__buttons'>
                                <button className='section-videoBanner__buttons-theme'>Coming Soon</button>
                                <button className='section-videoBanner__buttons-white'>Download W3AI Vision</button>
                            </div>
                        </div>


                    </div>
                </section>

            </main>
            <FooterNew />
        </div>
    )
}

export default AIcompute